import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';
import TextTableCell from 'components/common/table/TextTableCell';
import { ADMIN_PROPERTIES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const PropertyItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const canWrite = usePermission(ADMIN_PROPERTIES_WRITE);

  const handleEdit = useCallback(() => {
    historyContext.push(`/properties/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow hover key={data.id}>
      <TextTableCell content={data.name} />
      <TextTableCell content={data.code} />
      <TableCell>{data.type}</TableCell>
      <TableCell align='right'>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.id)}
            disabled={!canWrite}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

PropertyItem.propTypes = {
  data: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default React.memo(PropertyItem);
